<template>
	<div>
		<!-- <div class="course mb-50 mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">直播预告</h3>
				<router-link tag="span" :to="{path:'/course?type=3&name=zbyg&is_group=0'}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<LiveCourse :parentsData="dataProp" :name="'zbyg'"></LiveCourse>
		</div> -->
		<div class="course mt-50">
			<div class="flex-space title">
				<h3 class="fsm6">推荐课程</h3>
				<router-link tag="span" :to="{path:'/course?type=7&name=tjkc'}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataClass" :name="'tjkc'" :isLeft="2"></GroupCourse>
		</div>
		<!-- <router-link tag="div" :to="{path:'/'}">
			<img src="../../../../static/del/pro.jpg" alt="">
		</router-link> -->
		<div class="course mt-20 mb-50">
			<div class="flex-space title">
				<h3 class="fsm6">拼团报课</h3>
				<router-link tag="span" :to="{path:'/course?type=1'+'&name=ptbk'}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<div class="group">
				<div class="group" v-if="dataGroup.length > 0">
					<el-scrollbar>
						<PtCourse :ptProp="dataGroup"></PtCourse>
					</el-scrollbar>
				</div>
				<div class="mt-noData" v-else>
					<noData></noData>
				</div>
			</div>
		</div>
		<div class="course mt-20">
			<div class="flex-space title">
				<h3 class="fsm6">精品推荐</h3>
				<router-link tag="span" :to="{path:'/course?type='+7+'&name=jptj&code='+propCode}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<GroupCourse :Data="dataHomeJing" :name="'jptj'"></GroupCourse>
		</div>
		<div class="course mt-20">
			<div class="flex-space title">
				<h3 class="fsm6">书籍推荐</h3>
				<router-link tag="span" :to="{path:'/book'}" class="flex-alitem cursor">
					更多<img class="ml-5" src="../../../../static/index/arr-r.png" width="16px" height="16px" alt="">
				</router-link>
			</div>
			<div class="book mb-50">
				<el-scrollbar style="height: 400px;"  v-if="dataBook.length > 0">
					<bookCourse :bookProp="dataBook"></bookCourse>
				</el-scrollbar>
				<div class="mt-noData" v-else>
					<noData></noData>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import LiveCourse from '@/components/Course/live.vue'
	import PtCourse from '@/components/Course/ptClass.vue'
	import GroupCourse from '@/components/Course/group.vue'
	import bookCourse from '@/components/Course/book.vue'
	import noData from '@/components/noData/index.vue'
	export default{
		components: {
			LiveCourse,
			GroupCourse,
			PtCourse,
			bookCourse,
			noData
		},
		props: {
			dataProp: {
				type: Array,
				default: () => { return [] }
			},
			dataHomeJing:{
				type:Object,
				default:()=>{ return {} }
			},
			dataGroup: {
				type: Array,
				default: () => { return [] }
			},
			dataClass: {
				type: Object,
				default: () => { return {} }
			},
			dataBook: {
				type: Array,
				default: () => { return [] }
			},
			propCode:{
				type:String,
				default:''
			}
		},
		data() {
			return {

			}
		},
		created() {
			this.getClass()
		},
		methods: {
			// 首页拼团报课
			getClass() {

			}
		}
	}
</script>

<style lang="less" scoped>
	.course{
		.title{
			margin-bottom: 25px;
		}
	}
	.group{
		.groupItem{
			width: 450px;
			background-color: #fff;
			padding: 25px 20px;
			display: inline-block;
			margin-right: 20px;
			box-shadow: 0 0 5px 1px #e5e5e5;
			&:hover{
				box-shadow: 0 0 5px 1px #cdcdcd;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/view/index/components/home.vue